module.exports = __webpack_public_path__ + "static/kliavlin-77283d7e7330754298bd77f2b9543bbd.jpg";